import { list, calculator, bookmarks, book, cube, settings, person, cart, bookmark } from 'ionicons/icons';
import { APPLINKS } from '../../resources/AppConst';

const { dashboard, company, ledgerList, login, signup, docs, stockItem, customerDetails, createInvoice, editBill, invoice, invoiceShow, purchaseEntry, purchaseList, ledger, expenses, stocks, reports } = APPLINKS;

export const appLinks = [
    {
        title: 'Invoices',
        url: invoice,
        icon: list
    },
    {
        title: 'Create Invoices',
        url: createInvoice,
        icon: calculator
    },

    {
        title: 'Documentation',
        url: docs,
        icon: bookmarks
    },
];
export const appAdminLinks = [

    {
        title: 'Create Invoices',
        url: createInvoice,
        icon: calculator
    },

    {
        title: 'View & Search Invoices',
        url: invoice,
        icon: list
    },

    {
        title: 'View Purchase Entry',
        url: purchaseEntry,
        icon: cart
    },
    {
        title: 'View Purchase List',
        url: purchaseList,
        icon: bookmark
    },

    {
        title: 'View Accounts & Ledger',
        url: ledger,
        icon: book
    },
    {
        title: 'Stocks & Inventory',
        url: stocks,
        icon: cube
    },
    {
        title: 'Settings ',
        url: APPLINKS.settings,
        icon: settings
    },
    {
        title: 'Register User',
        url: signup,
        icon: person
    },
];